var React = require('react');

function ArrowDownSmall (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M10 7L13 11L16 7H10Z","fill":"#181818"}));
}

ArrowDownSmall.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = ArrowDownSmall;

ArrowDownSmall.default = ArrowDownSmall;
